import React from "react";
import styled from "styled-components";

export const SocialLink = ({
  children,
  href,
  onClick,
}: {
  children: React.ReactNode;
  href: string;
  onClick?: () => void;
}) => {
  return (
    <Social href={href} target="_blank" onClick={onClick}>
      {children}
    </Social>
  );
};
const Social = styled.a`
  width: ${({ theme }) => theme.sizes.socialIconSize};
  height: ${({ theme }) => theme.sizes.socialIconSize};
  background-color: ${({ theme }) => theme.colors.iconBackground};
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  > svg {
    opacity: 0.56;
    fill: ${({ theme }) => theme.colors.icon};
    height: calc(${({ theme }) => theme.sizes.socialIconSize} / 2);
    max-height: 14px;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
    * {
      fill: ${({ theme }) => theme.colors.icon};
    }
  }
  &:hover,
  &:focus,
  &:focus-within,
  &:focus-visible {
    background-color: ${({ theme }) => theme.colors.iconBackgroundHover};
    > svg {
      opacity: 1;
      fill: ${({ theme }) => theme.colors.iconHover};
      * {
        fill: ${({ theme }) => theme.colors.iconHover};
      }
    }
  }
  &:focus,
  &:focus-within,
  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.colors.iconBackgroundHover};
  }
`;
